import { render, staticRenderFns } from "./CellRendererHistory.vue?vue&type=template&id=0b70d352"
import script from "./CellRendererHistory.vue?vue&type=script&lang=js"
export * from "./CellRendererHistory.vue?vue&type=script&lang=js"
import style0 from "./CellRendererHistory.vue?vue&type=style&index=0&id=0b70d352&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports